import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ImplementationPlanService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getImplementationPlan(strategyId: number, initiativeId: number, startDate?: Date, endDate?: Date): Observable<any> {
    return this.http.get(`${this.baseUrl}/strategies/${strategyId}/plan/implementation-plan/initiatives/${initiativeId}`)
      .pipe(map((result: any) => {
      return result;
    }));
  }
}
